var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLeave = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.16667H10V2.5H2.5V17.5H10V15.8333H4.16667V4.16667Z",
    fill: "#6D6F71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.0001L14.1667 6.66675V9.16675H7.5V10.8334H14.1667V13.3334L17.5 10.0001Z",
    fill: "#6D6F71"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Leave.b5e0bba7.svg";
export { ForwardRef as ReactComponent };